import './day-of-month';
import './day-of-week';
import './day-of-year';
import './hour';
import './minute';
import './month';
import './second';
import './week';
import './week-calendar-utils';
import './year';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/ngx-bootstrap/bs-moment/units/index.js
// module id = ../../../../ngx-bootstrap/bs-moment/units/index.js
// module chunks = 3